import request, { HttpMethod } from '@app/libs/request';
import config from '@app/config';
import { OrganizationServerResponse } from '@app/domain/userManagement/organizations';
import { ORGANIZATION_HEADER_NAME } from '@app/utils/userIdentityHeadersGenerator';
import {
  KnoxerIdentityProvidersServerResponse,
  UpdateOrganizationIdentityProvidersRequest,
} from '@app/domain/userManagement/identityProviders';

export async function getAllIdentityProvidersOfOrganization(
  organizationId: string,
): Promise<KnoxerIdentityProvidersServerResponse[]> {
  return request<KnoxerIdentityProvidersServerResponse[]>(
    config.serverUrls.backee,
    `/api/organizations/${encodeURIComponent(organizationId)}/identity-providers`,
    {
      method: HttpMethod.get,
      errorsHandler: {
        default: {
          message: 'Cannot get IdentityProviders of organization.',
        },
      },
    },
  );
}

export async function getIdentityProvidersOfCurrentOrganization(
  organizationId: string,
): Promise<KnoxerIdentityProvidersServerResponse[]> {
  return request<KnoxerIdentityProvidersServerResponse[]>(config.serverUrls.backee, `/api/organizations/identity-providers`, {
    method: HttpMethod.get,
    headers: {
      [ORGANIZATION_HEADER_NAME]: organizationId,
    },
    errorsHandler: {
      default: {
        message: 'Cannot get IdentityProviders of organization.',
      },
    },
  });
}

export async function updateIdentityProvidersOfOrganization(
  organizationId: string,
  knoxerId: string,
  change: UpdateOrganizationIdentityProvidersRequest,
): Promise<OrganizationServerResponse> {
  return request<OrganizationServerResponse>(
    config.serverUrls.backee,
    `/api/organizations/${encodeURIComponent(organizationId)}/identity-providers`,
    {
      data: {
        knoxerId,
        ...change,
      },
      method: HttpMethod.patch,
      errorsHandler: {
        default: {
          message: 'Cannot update the identity providers of the organization.',
        },
      },
    },
  );
}
